/* common */
export const DEV_URL = "“https://signandplus.com/signup/14123426523423";
export const DEFAULT_LOCALES = "en";
// 
// test
//
export const TOKEN_PER_SELF_SIGN_JOB = 0;
export const TOKEN_PER_GROUP_SIGN_JOB = 0;
export const ALLOW_TOKEN_PURCHASE = false;
/* common */

/**/
// AWS for Massachusetts-MW stack
export const SERVER_URL = "https://d299wx9p5924p0.cloudfront.net";
export const cid = "d299wx9p5924p0";
export const apiKey = "w5M4Xte7Uz64ZW538WQh";
export const WSS_URL =
  "wss://auumsrqa1h.execute-api.us-east-1.amazonaws.com/prod";
export const userPoolId = "us-east-1_8MhNtnGkL";
export const userPoolClientId = "5vg7n3brud0mkr9ki93h95cl65";

 /**/


/**
// AWS for production stack
export const  SERVER_URL = 'https://dycmimr978xty.cloudfront.net';
export const  cid = 'dycmimr978xty';
export const  apiKey = "MN75siIT2Y6yqUA0p3Tb";
export const WSS_URL = 'wss://21jrx18ho4.execute-api.us-west-2.amazonaws.com/prod';
export const userPoolId = 'us-west-2_XtiG0mkGY';
export const userPoolClientId = '1h09qlmamonjsd1m7rrufvu8hg';
 **/
